import {TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Rating} from '@mui/material';

export default function Courses({courses}){

    return <TableContainer component={Paper}>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell align='left'><b>Formation</b></TableCell>
                    <TableCell align='center'><b>Inscriptions</b></TableCell>
                    <TableCell align='center'><b>Avis</b></TableCell>
                    <TableCell align='center'><b>Complétion moy.</b></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {courses.map(c => 
                    <TableRow key={c.id}>
                        <TableCell>{c.title}</TableCell>
                        <TableCell align='right'>{c.enrollments.toLocaleString()}</TableCell>
                        <TableCell align='center'>
                            <>
                                <Rating value={c.rating} precision={0.1} readOnly/>
                                <br/>
                                <span>{c.rating} ({c.reviews.toLocaleString()})</span>
                            </>
                        </TableCell>
                        <TableCell align='right'>{Math.round(c.completion)}<small>%</small></TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    </TableContainer>
}